import { PlaceholderLayout } from "atoms";
import { useAuth } from "features/auth";
import { LoggedInHomePage, LoggedOutHomePage } from "features/hub";
import { Head } from "features/misc";
import { defaultMetaData } from "features/system";

function HomePage() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <PlaceholderLayout />;
  }

  return (
    <>
      <Head title={defaultMetaData.pageTitle} />
      {user ? <LoggedInHomePage /> : <LoggedOutHomePage />}
    </>
  );
}

export default HomePage;
